(function() {
  'use strict';

  function formatDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = date.getDate();
    
    return `${dayName} ${monthName} ${day}`;
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const dow = result.getDay();
      if (dow !== 0 && dow !== 6) {
        added++;
      }
    }
    return result;
  }

  function calculateShippingDates() {
    const dateRangeElements = document.querySelectorAll('[data-date-range]');
    
    if (dateRangeElements.length === 0) {
      return;
    }

    const today = new Date();

    const startDate = addBusinessDays(today, 2);
    const endDate = addBusinessDays(today, 5);

    const startDateFormatted = formatDate(startDate);
    const endDateFormatted = formatDate(endDate);

    dateRangeElements.forEach(function(element) {
      element.textContent = `${startDateFormatted} - ${endDateFormatted}`;
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calculateShippingDates);
  } else {
    calculateShippingDates();
  }

  // Re-initialize when new sections are loaded (for theme editor)
  document.addEventListener('shopify:section:load', calculateShippingDates);
  
  // Re-initialize when product form changes (variant updates)
  document.addEventListener('product:variant:change', calculateShippingDates);

  // Handle return policy link clicks - scroll to and open shipping/return accordions
  function handleReturnPolicyClick() {
    const returnLinks = document.querySelectorAll('[data-scroll-to-accordion]');
    
    returnLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Find the accordion group
        const accordionGroup = document.querySelector('.accordion-group');
        
        if (!accordionGroup) {
          return;
        }
        
        // Get all accordion block items in the group
        const accordionBlocks = accordionGroup.querySelectorAll('.product-info__block-item[data-block-type="accordion"]');
        
        if (accordionBlocks.length < 2) {
          return;
        }
        
        // Open the 2nd and 3rd accordions (index 1 and 2)
        for (let i = 1; i < Math.min(3, accordionBlocks.length); i++) {
          const accordionDisclosure = accordionBlocks[i].querySelector('accordion-disclosure');
          if (accordionDisclosure) {
            const details = accordionDisclosure.querySelector('details.accordion__disclosure');
            // Only open if not already open
            if (details && !details.hasAttribute('open')) {
              // Trigger the custom element's toggle method to properly animate
              accordionDisclosure.toggle(true, true);
            }
          }
        }
        
        // Scroll to the first of these accordions (2nd accordion)
        accordionBlocks[1].scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center'
        });
      });
    });
  }

  // Initialize return policy click handlers
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleReturnPolicyClick);
  } else {
    handleReturnPolicyClick();
  }

  // Re-initialize when new sections are loaded (for theme editor)
  document.addEventListener('shopify:section:load', handleReturnPolicyClick);
})();

